// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previousLocation_VdrY5 {
  height : '40px'; 
  background-color : 'white'; 
  padding : 8px, 16px, 8px, 16px;
}

.radioButton_hFK9_ {
  background-color: var( --color-white );
  border-radius : 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/editors/dataSharing/DataSharingViewClasses.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB","sourcesContent":[".previousLocation {\n  height : '40px'; \n  background-color : 'white'; \n  padding : 8px, 16px, 8px, 16px;\n}\n\n.radioButton {\n  background-color: var( --color-white );\n  border-radius : 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previousLocation": `previousLocation_VdrY5`,
	"radioButton": `radioButton_hFK9_`
};
export default ___CSS_LOADER_EXPORT___;
